import {BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import './App.css';

import LoginPage from './login/LoginPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../src/assets/styles/styles.css';
import { Dashboard } from './dashboard/Dashboard';
import { Users } from './userDetails/Users';

function App() {
  return (
      
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/users" element={<Users />} />
      </Routes>
    
  );
}

export default App;
